const normalizeKey = (value) =>
  value == null ? "" : value.toString().toLowerCase();

export const hasCompetitionIdInQueue = (queue = [], competitionId) => {
  const normalizedCompetitionId = normalizeKey(competitionId);
  if (!Array.isArray(queue) || normalizedCompetitionId === "") {
    return false;
  }

  return queue.some((queuedId) => normalizeKey(queuedId) === normalizedCompetitionId);
};

export const shouldProcessCompetitionSnapshot = ({
  competitionData,
  currentSessionId,
  hasLocalCompetition,
}) => {
  if (!competitionData) {
    return false;
  }

  const normalizedModifiedBy = normalizeKey(competitionData.modified_by);
  const normalizedSessionId = normalizeKey(currentSessionId);

  return normalizedModifiedBy !== normalizedSessionId || hasLocalCompetition === false;
};

export const shouldRemoveLocalCompetitionOnMissingSnapshot = ({
  hasSeenExistingSnapshot = false,
  hasPendingCompetitionWrite = false,
  hasPendingCompetitionDeletion = false,
}) => {
  if (hasPendingCompetitionWrite) {
    return { shouldRemove: false, reason: "pending-write" };
  }

  if (hasPendingCompetitionDeletion) {
    return { shouldRemove: true, reason: "pending-deletion" };
  }

  if (hasSeenExistingSnapshot) {
    return { shouldRemove: true, reason: "doc-removed-after-existing" };
  }

  return { shouldRemove: false, reason: "missing-before-first-existing" };
};

export const propagateCompetitionTransactionError = ({
  error,
  competitionId,
  logger = console,
}) => {
  logger.error("Competition transaction failed:", competitionId, error);
  throw error;
};

export const hasRejectedTransactionResults = (results = []) =>
  results.some((result) => result?.status === "rejected");
